const { default: gql } = require('graphql-tag');

const CreateMercadoPagoPreferenceMutation = gql`
  mutation CreateMercadoPagoPreferenceMutation($orderId: ID!){
    ReparafoneCreateMercadopagoPreference(orderId: $orderId)
  }
`;

export default CreateMercadoPagoPreferenceMutation;
